import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

const API_URL = process.env.VUE_APP_MANAGER_API_URL;
document.title = "Voyado Onsite Manager";

export default createStore({
  state: {
    callLogSite: "",
    title: "Home",
    apiURL: API_URL,
    loader: false,
    prevCompanyId: "",
    activeRoute: "",
    cognitoInfo: {},
    faceBookpopup: [],
    dashboardInfo: {},
    menudataInfo: {},
    routedataInfo: {},
    filterInfo: {},
    dashboardFilter: {},
    leads: {},
    headerSidebar: {},
    emailforforgotpassword: "",
    integrationsValue: "Shopware",
    moduleValue: "Accelerator",
    email: "",
    session: "",
    accProducts: "0",
    accOrder: "0",
    accMarket: "0",
    accContact: "0",
    accInventory: "0",
    accReceipt: "0",
    isMultiPromotionsEnable: false,
    isTargetingAndBehaviourEnable: false,
    notifiedErrorCount: -1,
    globalSearch: {
      value: "",
      matchMode: "contains", // You can adjust this based on your needs
    },
    selectedLanguage: "en",
    routes: [
      { Name: "/", Value: "home" },
      { Name: "/essence", Value: "essence" },
      { Name: "/deals", Value: "modifydeal" },
      { Name: "/site/list", Value: "sitelist" },
      { Name: "/site/create", Value: "sitecreate" },
      { Name: "/site/edit/:id", Value: "siteedit" },
      { Name: "/sites", Value: "newsitelist" },
      { Name: "/acceleratorsite", Value: "acceleratorsite" },
      { Name: "/acceleratorsite/:id", Value: "acceleratoredit" },
      { Name: "/leadads", Value: "leadadslist" },
      { Name: "/elevatelist", Value: "elevatelist" },
      { Name: "/elevatelist/:id", Value: "elevateedit" },
      { Name: "/newsite/create", Value: "newsitecreate" },
      { Name: "/newsite/edit/:id", Value: "newsiteedit" },
      { Name: "/newsite/copy/:id", Value: "newsitecopy" },
      { Name: "/site/copy/:id", Value: "sitecopy" },
      { Name: "/deal/list", Value: "deallist" },
      // { Name: "/deal/create", Value: "dealcreate" },
      { Name: "/deal/edit/:id", Value: "dealedit" },
      { Name: "/performance", Value: "performance" },
      { Name: "/myambassadors", Value: "myambassadors" },
      { Name: "/myfriends", Value: "myfriends" },
      { Name: "/relations", Value: "relations" },
      { Name: "/user/list", Value: "userlist" },
      { Name: "/user/create", Value: "usercreate" },
      { Name: "/user/edit/:id", Value: "useredit" },
      { Name: "/companies", Value: "companylist" },
      { Name: "/company/create", Value: "companycreate" },
      { Name: "/company/edit/:id", Value: "companyedit" },
      { Name: "/changelog/:id", Value: "changelog" },
      { Name: "/changelog/:id", Value: "changelog" },
      { Name: "/contact/list", Value: "contactlist" },
      { Name: "/errorsummary", Value: "errorsummary" },
      { Name: "/calllog", Value: "calllogsite" },
      { Name: "/calllog/:id", Value: "calllogdashboard" },
      { Name: "/calllog/:id/:keyid", Value: "calllogview" },
      { Name: "/sessiondashboard", Value: "sessionssite" },
      { Name: "/sessiondashboard/:id", Value: "sessionsdashboard" },
      { Name: "/sessiondashboard/:id/:keyid", Value: "sessionsview" },
      // { Name: "/errorlog", Value: "errorsite" },
      // { Name: "/errorlog/:id", Value: "errordashboard" },
      { Name: "/errorlogbycompany", Value: "companyerrordashboard" },
      { Name: "/errorlogbycompany/:id", Value: "companyerrorview" },
      { Name: "/sitechangelog/:id", Value: "siteChangelog" },
      { Name: "/companychangelog/:id", Value: "companyChangelog" },
      { Name: "/editdealnew/:id", Value: "editdeal" },
      { Name: "/editdeal/:id", Value: "editdealnew" },
      { Name: "/newonsitemessage", Value: "newonsitemessage" },

      { Name: "/deals/deallist", Value: "managedeallistnew" },
      { Name: "/deals/deallistnew", Value: "managedeallist" },
      { Name: "/copydealnew/:id", Value: "copydeal" },
      { Name: "/copydeal/:id", Value: "copydealnew" },
      { Name: "/searchdeal/:id", Value: "dealsearch" },
      { Name: "/deals/create", Value: "managedealupdateCreate" },
      { Name: "/deals/edit/:id", Value: "managedealupdateById" },
      {
        Name: "/updatetranslation",
        Value: "updatetranslation",
      },
      { Name: "/newdeal/newcreate", Value: "newdealcreate" },
      { Name: "/neweditdeal/:id", Value: "neweditdeal" },
      { Name: "/notfound", Value: "notfound" },
      { Name: "/signupwizard", Value: "signupwizard" },
      { Name: "/newdealwizard", Value: "newdealwizard" },
      // { Name: "/managedealupdate", Value: "managedealupdate" },
      { Name: "/overview", Value: "overview" },
      { Name: "/contentgenerator", Value: "contentgenerator" },
      { Name: "/aicontent", Value: "aicontent" },
      { Name: "/leadads/:id", Value: "leadads" },
      // { Name:"/acceleratordashboard", Value:"acceleratordashboard"},
      { Name: "/acceleratordashboard/products", Value: "productsite" },
      { Name: "/acceleratordashboard/products/:id", Value: "productdashboard" },
      {
        Name: "/acceleratordashboard/products/:id/:keyid",
        Value: "productview",
      },
      { Name: "/acceleratordashboard/orders", Value: "ordersite" },
      { Name: "/acceleratordashboard/orders/:id", Value: "orderdashboard" },
      { Name: "/acceleratordashboard/orders/:id/:keyid", Value: "orderview" },
      { Name: "/acceleratordashboard/contacts", Value: "contactsite" },
      { Name: "/acceleratordashboard/contacts/:id", Value: "contactdashboard" },
      {
        Name: "/acceleratordashboard/contacts/:id/:keyid",
        Value: "contactview",
      },
      { Name: "/acceleratordashboard/inventories", Value: "inventorysite" },
      {
        Name: "/acceleratordashboard/inventories/:id",
        Value: "inventorydashboard",
      },
      {
        Name: "/acceleratordashboard/inventories/:id/:keyid",
        Value: "inventoryview",
      },
      { Name: "/acceleratordashboard/markets", Value: "marketsite" },
      { Name: "/acceleratordashboard/markets/:id", Value: "marketdashboard" },
      { Name: "/acceleratordashboard/markets/:id/:keyid", Value: "marketview" },

      { Name: "/acceleratordashboard/receipt", Value: "receiptsite" },
      { Name: "/acceleratordashboard/receipt/:id", Value: "receiptdashboard" },
      {
        Name: "/acceleratordashboard/receipt/:id/:keyid",
        Value: "receiptview",
      },
      { Name: "/essence", Value: "essence" },
    ],
  },
  plugins: [
    createPersistedState({
      paths: [
        "cognitoInfo",
        "dashboardInfo",
        "filterInfo",
        "dashboardFilter",
        "menudataInfo",
        "routedataInfo",
        "faceBookpopup",
        "selectedLanguage",
        "headerSidebar",
        "leads",
        "integrationsValue",
        "moduleValue",
        "accProducts",
        "accOrder",
        "accMarket",
        "accContact",
        "accInventory",
        "accReceipt",
        "isMultiPromotionsEnable",
        "isTargetingAndBehaviourEnable",
        "callLogSite",
        "notifiedErrorCount",
        "email"
      ],
    }),
  ],
  getters: {
    GetRoutePath: (state) => (pathName) => {
      var routeObj = state.routes.filter(function (path) {
        if (path.Value == pathName) {
          return path.Name;
        }
      });
      if (routeObj.length > 0) {
        return routeObj[0].Name;
      }
    },
    getGlobalSearch: (state) => {
      return state.globalSearch;
    },
  },
  mutations: {
    setCallLogsSite(state, value) {
      state.callLogSite = value;
    },
    resetCallLogLogout(state) {
      state.callLogSite = "";
    },
    setIntegrationsValue(state, value) {
      state.integrationsValue = value;
    },
    setModuleValue(state, value) {
      state.moduleValue = value;
    },
    setAcceleratorProducts(state, value) {
      state.accProducts = value;
    },
    setAcceleratorOrders(state, value) {
      state.accOrder = value;
    },
    setAcceleratorMarket(state, value) {
      state.accMarket = value;
    },
    setAcceleratorContact(state, value) {
      state.accContact = value;
    },
    setAcceleratorInventory(state, value) {
      state.accInventory = value;
    },
    setAcceleratorReceipt(state, value) {
      state.accReceipt = value;
    },
    setMultiPromotionsEnabled(state, value) {
      state.isMultiPromotionsEnable = value;
    },
    setTargetingAndBehaviourEnabled(state, value) {
      state.isTargetingAndBehaviourEnable = value;
    },
    setNotifiedErrorCount(state, value) {
      state.notifiedErrorCount = value;
    },
    resetNotifiedErrorCount(state) {
      state.notifiedErrorCount = -1;
    },
    resetAcceleratorProducts(state) {
      state.accProducts = "0";
    },
    resetAcceleratorOrders(state) {
      state.accOrder = "0";
    },
    setFacebookPopupWindowFalse(state, siteId) {
      const popupItem = state.faceBookpopup.find(
        (item) => item.siteid === siteId
      );
      if (popupItem) {
        popupItem.faceBookPopupwindow = false;
      }
    },

    resetAcceleratorMarket(state) {
      state.accMarket = "0";
    },
    resetAcceleratorContact(state) {
      state.accContact = "0";
    },
    resetAcceleratorInventory(state) {
      state.accInventory = "0";
    },
    resetAcceleratorReceipt(state) {
      state.accReceipt = "0";
    },
    resetIntegrationsValue(state) {
      state.integrationsValue = "Shopware";
    },
    resetModuleValue(state) {
      state.moduleValue = "Accelerator";
    },
    setHeaderSidebar(state, headerSidebar) {
      state.headerSidebar = headerSidebar;
    },
    resetHeaderSidebar(state) {
      state.headerSidebar = {};
    },

    setSelectedLanguage(state, language) {
      state.selectedLanguage = language;
    },
    setGlobalSearch(state, search) {
      state.globalSearch = search;
    },
    showLoader(state) {
      state.loader += 1;
    },
    hideLoader(state) {
      if (state.loader > 0) state.loader -= 1;
      else state.loader = 0;
    },
    replaceTitle(state, newtitle) {
      state.title = newtitle;
      document.title = "Voyado Onsite Manager - " + newtitle;
    },
    setForgotPasswordEmail(state, info) {
      state.emailforforgotpassword = info;
    },
    resetForgotPasswordEmail(state) {
      state.emailforforgotpassword = "";
    },
    setLoginEmail(state, info) {
      state.email = info;
    },
    resetLoginEmail(state) {
      state.email = "";
    },
    setSession(state, info) {
      state.session = info;
    },
    resetSession(state) {
      state.session = "";
    },
    setCognitoToken(state, info) {
      state.cognitoInfo.token = info;
    },
    setFaceBookpopupSite(state, info) {
      const existing = state.faceBookpopup.find(
        (item) => item.siteid === info.siteid
      );
      if (!existing) {
        state.faceBookpopup.push({
          siteid: info.siteid,
          faceBookPopupwindow: false,
        });
      }
    },

    setFaceBookpopupOpen(state, info) {
      const existing = state.faceBookpopup.find(
        (item) => item.siteid === info.siteid
      );
      if (existing) {
        existing.faceBookPopupwindow = info.faceBookPopupwindow;
      } else {
        state.faceBookpopup.push({
          siteid: info.siteid,
          faceBookPopupwindow: info.faceBookPopupwindow ?? false,
        });
      }
    },

    resetFacebookPopup(state) {
      state.faceBookpopup = [];
    },

    setCognitoUsername(state, info) {
      state.cognitoInfo.username = info;
    },
    setCognitoEmail(state, info) {
      state.cognitoInfo.email = info;
    },
    setLeadsData(state, info) {
      state.leads.isLead = info;
    },
    setEcomData(state, info) {
      state.leads.isEcom = info;
    },
    setisElevateEnableData(state, info) {
      state.leads.isElevate = info;
    },
    setisShowOnSiteMessages(state, info) {
      state.leads.isShowOnSiteMessage = info;
    },
    setCompanystoreId(state, info) {
      state.leads.companystoreid = info;
    },
    setCognitoInfo(state, info) {
      state.cognitoInfo = info;
    },
    resetCognitoInfo(state) {
      state.cognitoInfo = {};
    },
    resetLead(state) {
      state.leads = {};
    },
    setMenudataInfo(state, info) {
      state.menudataInfo = info;
    },
    resetMenudataInfo(state) {
      state.menudataInfo = {};
    },
    setRoutedataInfo(state, info) {
      state.routedataInfo = info;
    },
    resetRoutedataInfo(state) {
      state.routedataInfo = {};
    },
    replaceCompanyId(state, newid) {
      state.cognitoInfo.companyid = newid;
      state.prevCompanyId = newid;

      state.cognitoInfo.companylist.forEach((element) => {
        element.selected = false;
      });

      var _filtered = state.cognitoInfo.companylist.filter(
        (a) => a.value == newid
      )[0];
      _filtered.selected = true;
      state.cognitoInfo.companyname = _filtered.text;
    },
    resetDashbboardInfoData(state) {
      state.dashboardInfo.data = "";
    },
    setDashboardInfo(state, info) {
      state.dashboardInfo = info;
    },
    resetDashboardInfo(state) {
      state.dashboardInfo = {};
    },
    resetDashboardLastSync(state) {
      state.dashboardInfo.lastSync = null;
    },
    resetDashbboardFilter(state) {
      state.dashboardFilter = "";
    },
    setDashboardFilter(state, filter) {
      state.dashboardFilter = filter;
    },
    setGlobalFilter(state, text) {
      state.filterInfo.global = text;
    },
    resetDealFilter(state) {
      state.filterInfo = {};
    },
    removeGlobalFilter(state) {
      state.filterInfo.global = "";
    },
    setActiveRoute(state, value) {
      state.activeRoute = value;
    },
  },
});
